import gsap from 'gsap';

class Navigation {
    stateClasses = {
        open: 'nav--open',
        active: 'active',
        noScroll: 'no-scroll',
    };

    BREAKPOINT_DESKTOP = 992;
    MAX_SCROLL_MOVE = 40;
    SCROLL_THRESHOLD = 500;

    constructor($el) {
        this.$el = $el;

        this.$html = $('html');
        this.$header = $('.header');
        this.$marquee = $('.supermarquee-header');

        this.$trigger = this.$el.find('[data-nav="toggle"]');
        this.$menu = $('[data-nav="menu"]');
        this.$overlay = $('[data-nav="overlay"]');
        this.$close = $('[data-nav="close"]');
        this.$cursor = $('[data-nav="cursor"]');

        this.isOpen = false;
        this.isDesktop = window.innerWidth >= this.BREAKPOINT_DESKTOP;

        this.init();
    }

    init = () => {
        this.setupEvents();
        this.calculateHeader();

        this.onResize = () => {
            cancelAnimationFrame(this.resizeRAF);
            this.resizeRAF = requestAnimationFrame(this.handleResize);
        };

        $(window).on('resize', this.onResize);
    };

    handleResize = () => {
        const isDesktopNow = window.innerWidth >= this.BREAKPOINT_DESKTOP;

        if (isDesktopNow !== this.isDesktop) {
            this.teardownEvents();
            this.isDesktop = isDesktopNow;
            this.setupEvents();
        }

        this.calculateHeader();
    };

    setupEvents = () => {
        if (this.isDesktop) {
            this.$overlay.on('mouseenter', this.showCursor);
            this.$overlay.on('mouseleave', this.hideCursor);
            $(document).on('mousemove', this.moveCursor);
            this.$trigger.on('mouseenter', this.clickHandler);
        } else {
            this.$trigger.on('click', this.clickHandler);
        }

        this.$close.on('click', this.close);
        this.$overlay.on('click', this.close);
    };

    teardownEvents = () => {
        this.$overlay.off('mouseenter mouseleave click');
        this.$trigger.off('mouseenter click');
        this.$close.off('click');
        $(document).off('mousemove');
        $(window).off('scroll.triggerMove');
    };



    clickHandler = () => {
        this.isOpen ? this.close() : this.open();
    };

    open = () => {
        this.$html.addClass(this.stateClasses.noScroll);
        this.$html.addClass(this.stateClasses.open);
        this.$overlay.addClass(this.stateClasses.active);

        this.animateNavigation();
        this.isOpen = true;
    };

    close = () => {
        this.$html.removeClass(this.stateClasses.noScroll);
        this.$html.removeClass(this.stateClasses.open);
        this.$overlay.removeClass(this.stateClasses.active);

        this.isOpen = false;
    };



    animateNavigation = () => {
        const $items = this.$menu.find('p, li');

        if (this.$menu.is('[data-scroll="appear"]')) {
            gsap.set($items, { opacity: 0, y: -20 });

            $items.each((index, item) => {
                gsap.to(item, {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    delay: index * 0.1,
                    ease: 'power2.out',
                });
            });
        }
    };



    calculateHeader = () => {
        const marqueeHeight = this.$marquee.length
            ? this.$marquee.innerHeight()
            : 0;

        const headerHeight = this.$header.innerHeight();
        const triggerHeight = this.$trigger.innerHeight();

        const mobileAdjust = window.innerWidth > 992 ? 2 : 0;

        const offset =
            marqueeHeight +
            ((headerHeight - triggerHeight) / 2) +
            mobileAdjust;

        const offsetMenu = offset - triggerHeight / 2;

        this.$trigger.css({ top: offset, y: 0 });
        this.$menu.css({ top: offsetMenu, y: 0 });

        this.setupScrollMotion(marqueeHeight);
    };

    setupScrollMotion = (marqueeHeight) => {
        $(window).off('scroll.triggerMove');

        if (!marqueeHeight) return;

        const setTriggerY = gsap.quickSetter(this.$trigger, 'y', 'px');
        const setMenuY = gsap.quickSetter(this.$menu, 'y', 'px');

        $(window).on('scroll.triggerMove', () => {
            const scrollTop = $(window).scrollTop();
            const moveAmount = Math.min(
                this.MAX_SCROLL_MOVE,
                Math.max(
                    0,
                    (scrollTop / this.SCROLL_THRESHOLD) * this.MAX_SCROLL_MOVE
                )
            );

            setTriggerY(-moveAmount);
            setMenuY(-moveAmount);
        });
    };

    /* -------------------------
     * Cursor
     * ------------------------- */

    showCursor = () => {
        if (!this.isOpen) return;
        this.$cursor.addClass('is-visible');
    };

    hideCursor = () => {
        this.$cursor.removeClass('is-visible');
        gsap.killTweensOf(this.$cursor);
        gsap.set(this.$cursor, { scale: 1 });
    };

    moveCursor = (e) => {
        if (!this.isOpen) return;

        gsap.set(this.$cursor, {
            left: e.clientX,
            top: e.clientY,
        });
    };
}

export default Navigation;
